export default __webpack_public_path__ + "static/media/clickLow.f5e37169.mp3";